module["exports"] = [
  "(9##)###-##-##"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/phone_number/formats.js
// module id = 1651
// module chunks = 0